import React, { FunctionComponent, memo, ReactNode, useCallback } from 'react'

import { FetchResult } from '@apollo/client'
import { SpaceProps } from 'styled-system'

import { Spinner } from '@/atoms/spinner'

import { ButtonSize, ButtonVariant, StyledButton } from './styled-button'

interface OwnProps {
  onClick?: (() => void) | (() => Promise<FetchResult>)
  type?: 'submit' | 'button'
  disabled?: boolean
  loading?: boolean
  variant?: ButtonVariant
  size?: ButtonSize
  children?: ReactNode
  fullWidth?: boolean
  name?: string
  value?: string
}

type Props = OwnProps & SpaceProps

const Button: FunctionComponent<Props> = ({
  onClick,
  disabled = false,
  type = 'button',
  loading = false,
  variant = ButtonVariant.DEFAULT,
  size = ButtonSize.DEFAULT,
  fullWidth,
  children,
  ...rest
}) => {
  const handleClick = useCallback(
    e => {
      e.stopPropagation()
      if (!disabled && !loading) {
        onClick && onClick()
      }
    },
    [onClick, disabled, loading],
  )

  return (
    <StyledButton
      type={type}
      onClick={handleClick}
      disabled={disabled || loading}
      $variant={variant}
      $size={size}
      $fullWidth={fullWidth}
      {...rest}
    >
      {loading && <Spinner overlay />}
      {children}
    </StyledButton>
  )
}

Button.displayName = 'Button'

export default memo(Button)
